import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router';
import { Alert, Button } from '../components/ui';
import { loginUrl, safeNext, useSession } from '../lib/session';

/** Branded sign-in (D1): one button, no VaultSage copy. */
export function LoginPage() {
  const { t } = useTranslation();
  const [q] = useSearchParams();
  const { identity, loading } = useSession();
  if (!loading && identity) return <Navigate to={safeNext(q.get('next'))} replace />;
  const err = q.get('error');
  return (
    <div className="mx-auto mt-16 max-w-md space-y-6 rounded-xl border border-slate-200 bg-white p-8 text-center">
      <span className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-lg bg-emerald-600 text-2xl font-bold text-white">
        F
      </span>
      <h1 className="text-xl font-semibold">{t('login.title')}</h1>
      <p className="text-sm text-slate-600">{t('login.lead')}</p>
      {err && <Alert>{t('login.error', { code: err })}</Alert>}
      <Button className="w-full py-2" onClick={() => window.location.assign(loginUrl(q.get('next') ?? '/'))}>
        {t('login.button')}
      </Button>
      <p className="text-xs text-slate-500">{t('login.hint')}</p>
    </div>
  );
}
